import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './pages/Login';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';
import { PortfolioDashboard } from './pages/PortfolioDashboard';
import { ProjectSummary, ProjectSummaryContent } from './pages/ProjectSummary';
import { CustomerAlarms } from './pages/CustomerAlarms';
import { SiteAlarms } from './pages/SiteAlarms';
import { SiteContacts } from './pages/SiteContacts';
import { SiteMarketRoute } from './pages/SiteMarketRoute';
import { SiteCharts } from './pages/SiteCharts';
import { AdminUsers } from './pages/AdminUsers';
import { AdminSettings } from './pages/AdminSettings';
import { AdminSiteSettings } from './pages/AdminSiteSettings';
import { AdminOrgUnits } from './pages/AdminOrgUnits';
import { AdminNotificationAudit } from './pages/AdminNotificationAudit';
import { UserSettings } from './pages/UserSettings';
import Historian from './pages/Historian';
import { Reports } from './pages/Reports';
import { SecurityDashboard } from './pages/SecurityDashboard';
import { SecuritySiteDetail } from './pages/SecuritySiteDetail';
import { SecurityAuditLog } from './pages/SecurityAuditLog';
import { TicketList } from './pages/TicketList';
import { TicketCreate } from './pages/TicketCreate';
import { TicketDetail } from './pages/TicketDetail';
import { AlarmPrimitivesPreview } from './pages/dev/AlarmPrimitivesPreview';
import { ProtectedRoute } from './components/ProtectedRoute';
import { RoleGatedRoute } from './components/RoleGatedRoute';
import { AppLayout } from './components/layout/AppLayout';
import {
  ADMIN_ROLES,
  OPS_ADMIN_ROLES,
  ROLES_WITH_CHARTS,
  ROLES_WITH_HISTORIAN,
  ROLES_WITH_SECURITY,
} from './constants/roles';
import './styles/App.css';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
          <Route path="/dashboard" element={<PortfolioDashboard />} />
          <Route path="/alarms" element={<CustomerAlarms />} />
          <Route path="/project/:id" element={<ProjectSummary />}>
            <Route index element={<ProjectSummaryContent />} />
            <Route path="alarms" element={<SiteAlarms />} />
            <Route path="contacts" element={<SiteContacts />} />
            <Route path="market" element={<SiteMarketRoute />} />
          </Route>
          <Route path="/charts/:id" element={<RoleGatedRoute allowedRoles={ROLES_WITH_CHARTS}><SiteCharts /></RoleGatedRoute>} />
          <Route path="/historian" element={<RoleGatedRoute allowedRoles={ROLES_WITH_HISTORIAN}><Historian /></RoleGatedRoute>} />
          <Route path="/reports" element={<RoleGatedRoute allowedRoles={ROLES_WITH_HISTORIAN}><Reports /></RoleGatedRoute>} />
          <Route path="/tickets" element={<TicketList />} />
          <Route path="/tickets/new" element={<TicketCreate />} />
          <Route path="/tickets/:id" element={<TicketDetail />} />
          <Route path="/security" element={<RoleGatedRoute allowedRoles={ROLES_WITH_SECURITY}><SecurityDashboard /></RoleGatedRoute>} />
          <Route path="/security/site/:siteId" element={<RoleGatedRoute allowedRoles={ROLES_WITH_SECURITY}><SecuritySiteDetail /></RoleGatedRoute>} />
          <Route path="/security/audit-log" element={<RoleGatedRoute allowedRoles={ADMIN_ROLES}><SecurityAuditLog /></RoleGatedRoute>} />
          <Route path="/admin/users" element={<RoleGatedRoute allowedRoles={ADMIN_ROLES}><AdminUsers /></RoleGatedRoute>} />
          <Route path="/admin/settings" element={<RoleGatedRoute allowedRoles={ADMIN_ROLES}><AdminSettings /></RoleGatedRoute>} />
          <Route path="/admin/org-units" element={<RoleGatedRoute allowedRoles={ADMIN_ROLES}><AdminOrgUnits /></RoleGatedRoute>} />
          <Route path="/admin/sites/:id/settings" element={<RoleGatedRoute allowedRoles={ADMIN_ROLES}><AdminSiteSettings /></RoleGatedRoute>} />
          <Route path="/admin/notifications/audit" element={<RoleGatedRoute allowedRoles={OPS_ADMIN_ROLES}><AdminNotificationAudit /></RoleGatedRoute>} />
          <Route path="/settings/notifications" element={<UserSettings />} />
          {import.meta.env.DEV && (
            <Route path="/dev/alarm-primitives" element={<AlarmPrimitivesPreview />} />
          )}
        </Route>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
